import BenefitsSlider from "@components/BasicComponents/DBStudio/BenefitsSlider/BenefitsSlider"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

// import styles from "./BenefitsSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const BenefitsSection = (props: Props) => {
	return (
		<Separator
			backgroundColor={"#F8FAFE"}
			size={128}
			style={{overflow: "hidden"}}
		>
			<ContainerWrapper>
				<Typography
					content={props.data.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				{props.data?.mainContent && (
					<BenefitsSlider data={props.data?.mainContent} />
				)}
			</ContainerWrapper>
		</Separator>
	)
}

export default BenefitsSection
